import { SetStateAction } from "react";
import convertDate from "../../../utils/convertDate";
import { stdObject } from "../../../data/types/stdObject";
import { colors } from "../../../data/colors";

export const timeModal = ({
  t,
  windowValues,
  windowValues2,
  setModalData2,
  setWindowValues,
  setWindowValues2,
  closeMsg,
}: stdObject) => {
  return {
    title: t("p.selectTheTime"),
    label: convertDate({
      info: windowValues.nextDate,
      time: false,
      full: true,
      t,
    }),
    blocked: true,
    inputs: [
      {
        value: windowValues2.hour ?? "",
        type: "time",
        onChange: (v: { target: { value: SetStateAction<string> } }) =>
          setWindowValues2({
            hour: v.target.value,
          }),
      },
    ],
    buttons: [
      {
        label: t("p.apply"),
        onClick: () => {
          if (windowValues2.hour) {
            setWindowValues({
              ...windowValues,
              nextDate: `${windowValues.nextDate} ${windowValues2.hour}:00`,
            });
            setModalData2({});
            closeMsg(2);
          }
        },
        color: windowValues2.hour ? colors.blue : colors.grey,
      },
    ],
  };
};
